<template>
  <div class="content">
    <div class="title">
      <h2>问卷调查</h2>
    </div>
    <div>
      <ul class="list">
        <li class="item" v-for="(item, index) in listData.result" :key="index">
          <span class="surveyName beyondEllipsis" @click="openUrl(item)">{{ item.surveyName }}</span>
          <span class="time"
            >{{ item.publishTime.slice(0, 10) }}&nbsp;至&nbsp;{{
              item.stopTime.slice(0, 10)
            }}</span
          >
        </li>
      </ul>
      <el-pagination
        background
        style="text-align: right; background: none"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="listData.totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { survey_qy } from "@/api/home";
export default {
  data() {
    return {
      listData: {
        result: [],
      },
      pageNo: 1,
      pageSize: 30,
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    openUrl(item){
      window.open('http://sxgl.sxyyc.net/pro/static/publicQuestionnaire?type=pc&id='+item.surveyId)
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = val;
      this.getList();
    },
    getList() {
      survey_qy({
        op: "findPageSurvey",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.listData = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: -20px;
  background: url("~@/assets/img/pageBg.png") no-repeat !important;
  padding: 20px;
  .title {
    text-align: center;
  }

  .item {
    border-bottom: 1px #fff dotted;
  }
  .surveyName {
    display: inline-block;
    max-width: 800px;
    line-height: 40px;
  }
  .surveyName:hover {
    cursor: pointer;
    color: #1890ff;
  }
  .time {
    line-height: 40px;
    float: right;
  }
  .list {
    margin-bottom: 25px;
  }
}
</style>